export const VERSION = '11.0.0-preview.7.26381.103';
//# sourceMappingURL=pkg-version.js.map